import {
  pingServices,
  setServicesStatus,
  appNotify
} from '../store/actions';
import { getWithToken } from 'api/network';
import { takeLatest, put, select } from 'redux-saga/effects';
import { servicesStatusSelector } from 'store/selectors';
import { sendClientLog } from 'services/logService';

const extractFriendlyText = (names) => names.length === 0 ? 'None' : names.join(',')

export function* pingServicesSaga() {
  yield takeLatest(pingServices, function* () {
    try {
      const oldState = yield select(servicesStatusSelector);
      yield put(setServicesStatus({ ...oldState, loading: true }));
      const response = yield getWithToken(`/api/ping/services`);
      const data = yield response.json();

      yield put(setServicesStatus({ timestamp: Date.now(), loading: false, revue: true, data }));

      const unhealthyServiceNames = data.filter(oo => !oo.isHealthy).map(oo => oo.serviceName)
      const noDataReturnedServiceNames = data.filter(oo => !oo.dataReturned).map(oo => oo.serviceName)

      const serviceCheckSummary = `User pinged Services Status. Bad health: ${extractFriendlyText(unhealthyServiceNames)}. Bad data: ${extractFriendlyText(noDataReturnedServiceNames)}.`
      sendClientLog('Info', serviceCheckSummary);
    } catch (error) {
      sendClientLog('Info', 'User pinged Services Status. ReVUe failed health check.');
      yield put(setServicesStatus({ timestamp: Date.now(), loading: false, revue: false, data: [] }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}